<template lang="pug">
  div
    section.hero
      .hero-body
        .container
          //- img.logo(v-bind:src="logo", alt="logo")
          img.logo(src="/static/logo.png", alt="logo")
          h2.subtitle Admnistrador de libro de reclamaciones
      
    div.container
      .half-width.margin-auto
        h3.title Ingrese sus credenciales
            
        .field
          p.control.has-icons-left.has-icons-right
            input.input(type='text', placeholder='Usuario', v-model="username", @keyup.enter="login")
            span.icon.is-small.is-left
              i.fa.fa-user
        .field
          p.control.has-icons-left
            input.input(type='password', placeholder='Password', v-model="password", @keyup.enter="login")
            span.icon.is-small.is-left
              i.fa.fa-lock
        .field
          p.control.has-text-centered
            button.button.is-empresa(@click="login", :class="{'is-loading': isLoading}") Ingresar
        
        transition(name="fade")
          article.message.is-danger(v-if="errorMessage")
            .message-body
              strong {{errorMessage}}
          
</template>

<script>
import { apiPost } from '../util/general'
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false
    }
  },
  methods: {
    login () {
      var vm            = this
      this.isLoading    = true
      this.errorMessage = ''

      var obj = {
        username: this.username,
        password: this.password
      }

      apiPost(vm, '/libroreclamaciones/login', obj, function (data) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('username', data.username)
        localStorage.setItem('nombre', data.nombre)
        localStorage.setItem('email', data.email)
        window.location.reload(true)
        window.location.href = '/'
      }, function (error) {
        vm.errorMessage = error.message
        vm.isLoading = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .logo 
    width 350px
    margin-top 10px

  .hero
    margin-bottom 10px  
</style>



// WEBPACK FOOTER //
// View_Login.vue?161023a6